import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const config = {
    apiKey: "AIzaSyD97lXUNGFzv7CxuRBU0kJdR6kowzJraOo",
    authDomain: "takeair-46576.firebaseapp.com",
    databaseURL: "https://takeair-46576.firebaseio.com",
    projectId: "takeair-46576",
    storageBucket: "takeair-46576.appspot.com",
    messagingSenderId: "520180313396"
  };

firebase.initializeApp(config);

export default firebase;
export const db = firebase.firestore();
export const auth = firebase.auth();
export const provider = new firebase.auth.FacebookAuthProvider();
export const weather = {
  apiKey: "a5a71aafe7d12fe1e5a62cf8afeeaaec",
  baseUrl: "https://api.openweathermap.org/data/2.5/forecast"
};
